import { cn } from '@ifixit/ui/lib/utils';
import { Slot } from '@radix-ui/react-slot';
import { type ComponentProps } from 'react';

interface ButtonProps extends ComponentProps<'button'> {
   asChild?: boolean;
}

function Button({ className, asChild = false, ...props }: ButtonProps) {
   const Comp = asChild ? Slot : 'button';

   return <Comp data-slot="button" className={cn(className)} {...props} />;
}

export { Button };
